const calculateHP = (vigor) =>{
    const maxHP = vigor* 3.2
    return Math.round(maxHP)
}

export default calculateHP